import React, { useState, useEffect } from 'react';
import './BackToTop.css';

const BackToTop = () => {
    const [isFixed, setIsFixed] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    
    // Function to scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    
    useEffect(() => {
        // Function to handle scroll events
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
            
            const categoryCardsPosition = document.querySelector('.category-cards-container')?.offsetTop;
            const moreCardBottom = categoryCardsPosition ? categoryCardsPosition + document.querySelector('.category-cards-container')?.offsetHeight : 0;
            
            if (categoryCardsPosition && window.scrollY >= moreCardBottom - 100) {
                setIsFixed(false);
            } else {
                setIsFixed(true);
            }
        };
        
        window.addEventListener('scroll', handleScroll);
        
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    
    return (
        <div className={`back-to-top ${isVisible ? 'visible' : ''} ${isFixed ? 'fixed' : 'absolute'}`} onClick={scrollToTop}>
            <div className="back-to-top-content">
                {/* SVG isosceles hollow triangle with thicker border */}
                <svg width="24" height="20" viewBox="0 0 24 20" className="hollow-triangle-svg">
                    <path 
                        d="M12 2L22 18H2L12 2Z" 
                        fill="transparent" 
                        stroke="#4ADE80" 
                        strokeWidth="2.5"
                    />
                </svg>
                <span className="back-text">Back to Top</span>
            </div>
        </div>
    );
};

export default BackToTop;